import { callApi } from './api';

import { Template, CreateTemplateRequest } from '@/types/template';

export const createTemplate = async (requestBody: CreateTemplateRequest) => {
  const { status, result } = await callApi<Template>(
    'templates',
    'POST',
    undefined,
    requestBody,
    undefined,
    undefined,
    true
  );
  return { status, result };
};
